import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { mapSixFilesApiResponseToFileEntries } from '@/store/mappers/mapSixDetail';
import { setFiles } from '@/store/slices/sixDetail/sixDetailSlice';
import { syncFilesFromApiThunk } from '@/store/thunks/sixDetail/syncFilesFromApiThunk';

export const refreshFilesFromApi = createAppAsyncThunk(
  'sixDetail/refreshFilesFromApi',
  async(sixId: string, { dispatch, extra, getState }) => {
    const state = getState().sixDetail;
    const filesResponse = await extra.sixDetailService.fetchFiles(sixId, {
      filters: state.activeFilters,
      search: state.search,
      sortKey: state.sortKey,
      sortDir: state.sortDir,
    });

    const files = mapSixFilesApiResponseToFileEntries(filesResponse);
    dispatch(setFiles(files));
    void dispatch(syncFilesFromApiThunk({ sixId, files }));

    return {
      skipped: false,
      files,
    };
  }
);
